<div class="panel panel--components">
  <div class="panel__header">
    <div class="form-item">
      <label class="form-label">Inspection Type</label>
      <mat-form-field class="input">
        <mat-select style="align-content: center" (change)="InspectionTypeChange()" [(ngModel)]="SelectedInspectionTypeId_"
                    placeholder="{{'Inspection Type'}}" multiple>
          <mat-option [value]="-1">All Types</mat-option>
          <mat-option [value]="0">Full Inspection</mat-option>
          <mat-option *ngFor="let type of inspectionTypesList" [value]="type.Id">
            {{ type.Name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

    </div>
    <div>
      <section class="example-section">
        <mat-checkbox class="example-margin" [(ngModel)]="checkedMeasurement">Measurement</mat-checkbox>
        <mat-checkbox class="example-margin" [(ngModel)]="checkedWorn">Worn %</mat-checkbox>
        <mat-checkbox class="example-margin" [(ngModel)]="checkedWeightedWorn">Weighted Worn %</mat-checkbox>

      </section>
    </div>

    <button mat-raised-button color="warn" (click)="LoadMore()">
      <span class="material-icons button__icon">add</span><span class="button__text">Load More</span>
    </button>
  </div>

  <div>

    <div>
      <div class="panel__content no-padding">
        <div class="center" *ngIf="inspectionsHistory==null || loading==true">
          <mat-spinner></mat-spinner>
        </div>

        <div style="display: flex;flex-direction: row;" *ngIf="LeftSystem!=null && inspectionsHistory!=null ">
          <div style="width:40%">
            <table class="table table--striped table--full-width">
              <tr>
                <td></td>
                <td class="tdClass" style="padding: 13px;font-size: 19px;">Notes</td>
              </tr>
              <tr>
                <td class="tdClass"> {{eqName}}</td>
                <td class="tdClass">DATE</td>
              </tr>
              <tr>
                <td></td>
                <td class="tdClass">SMU</td>
              </tr>
              <tr *ngIf="(FamilyId==177 || FamilyId==203)">
                <td></td>
                <td class="tdClass">Propel Hrs</td>
              </tr>
              <tr *ngIf="(FamilyId==177 || FamilyId==203)">
                <td></td>
                <td class="tdClass">Propel %</td>
              </tr>
              <tr *ngIf="(FamilyId==177 || FamilyId==203)">
                <td></td>
                <td class="tdClass">Crawler Belt Propel Hrs</td>
              </tr>
              <tr *ngIf="(FamilyId==177 || FamilyId==203)">
                <td></td>
                <td class="tdClass">Crawler Belt Propel %</td>
              </tr>
              <tr>
                <td></td>
                <td class="tdClass">Inspector</td>
              </tr>
              <tr>
                <td class="tdClass">Left Side</td>
                <td *ngIf="(FamilyId!=177 && FamilyId!=203)" class="tdClass">Components</td>
                <td *ngIf="(FamilyId==177 || FamilyId==203)" class="tdClass">Type</td>
              </tr>
              <tr>
                <td></td>
                <td class="tdClass">Residual Life</td>
              </tr>
              <tr>
                <td></td>
                <td class="tdClass">Crawler Belt CMU</td>
              </tr>
              <tr>
                <td></td>
                <td style="padding: 23px;" class="tdClass">Left Side UC Weighted % Worn</td>
              </tr>
              <ng-container *ngFor="let info of LeftSystem">
                <tr>
                  <td></td>
                  <td class="tdClass" style="padding: 19px 17px;cursor: pointer;" (click)="ExpandCompatyType(info,1)">
                    <span>
                      <span class="material-icons" style="vertical-align: middle;" *ngIf="!info.isExpand">
                        add
                      </span>
                      <span class="material-icons" style="vertical-align: middle;" *ngIf="info.isExpand">remove </span>
                      <span style="font-weight: bolder;">
                        {{info.Name}} {{
showPosition(info.Position,
                        info.CompartTypeId)
                        }}
                      </span>
                    </span>
                  </td>


                </tr>

                <ng-container *ngIf="info.isExpand">
                  <ng-container *ngFor="let mp of info.MPRecords">
                    <tr>
                      <td class="component-cell">
                        <div class="component-photo-container">
                          <img class="component-photo" [src]="getImage(mp.Photo)"
                               (click)="viewPhoto(mp.Photo)" />
                        </div>
                      </td>
                      <td class="tdClass" style="padding: 19px 17px;cursor: pointer;">
                        <span>
                          {{mp.Name}}
                        </span>
                      </td>
                    </tr>
                  </ng-container>

                </ng-container>

              </ng-container>



            </table>
          </div>

          <div style="overflow-x: auto;">
            <table class="table table--striped table--full-width">
              <div style="display: flex; flex-direction: row;">
                <ng-container *ngFor="let data of inspectionsHistory">
                  <div>
                  <tr>
                    <td class="tdClass" style="padding: 10px;text-align: center;font-size: 16px;">
                      <i class="material-icons square-button__icon" (click)="OpenInspectionComment(data)"
                         style="cursor: pointer;" title="General Notes">description</i>
                    </td>

                  </tr>
                  <tr>
                    <td class="tdClass">{{data.Date}}</td>

                  </tr>
                  <tr>

                    <td class="tdClass">{{data.Smu}}</td>
                  </tr>
                  <tr *ngIf="(FamilyId==177 || FamilyId==203)">

                    <td class="tdClass">{{data.EPMU}} </td>
                  </tr>
                  <tr *ngIf="(FamilyId==177 || FamilyId==203)">

                    <td class="tdClass">{{data.PMUpercentage.toFixed(1)}}% </td>
                  </tr>
                  <tr *ngIf="(FamilyId==177 || FamilyId==203)">

                    <td class="tdClass">{{data.CrawlerBeltEPMU}} </td><!-- Craweler Propel-->
                  </tr>
                  <tr *ngIf="(FamilyId==177 || FamilyId==203)">

                    <td class="tdClass">{{data.CrawlerBeltPMUpercentage.toFixed(1)}}% </td><!-- Craweler Propel %-->
                  </tr>
                  <tr>
                    <td class="tdClass">{{data.Inspector | aesDecrypt}} </td>
                  </tr>
                  <tr>
                    <td *ngIf="(FamilyId!=177 && FamilyId!=203)" class="tdClass">Worn%</td>
                    <td *ngIf="(FamilyId==177 || FamilyId==203)" class="tdClass SerialAndUnitText">{{data.InspectionType}}</td>
                  </tr>
                  <tr>
                    <td class="tdClass">{{data.MonoblockResidualL}} </td>
                  </tr>
                  <tr>
                    <td class="tdClass">{{data.MonoblockCMUL}} </td>
                  </tr>
                  <tr>
                    <td class="tdClass">

                        <span *ngIf="data.SumWornL!=null" class="Eval-{{ data.SumWornL | wornPercentageToEval}}"
                          style="margin-right: 7px;padding: 10px 17px; margin-top: 15px;" >
                          <div>{{data.SumWornL?.toFixed(1)}}%</div>
                        </span>
                        <span *ngIf="data.SumWornL==null" class="Eval-U" style="margin-right: 7px;padding: 7px 21px;">
                          <div>-</div>
                        </span>
                      </td>
                    </tr>

                  <ng-container *ngFor="let info of data.LeftSide">
                    <tr>

                        <td class="tdClass" style="display: flex;justify-content: space-between;padding: 16px 17px;">
                         <!--TT-3983-->
                          <!-- <span class="Eval-{{ info.Eval}}" style="margin-right: 7px;padding: 7px 21px;">
                            <div>{{info.Worn?.toFixed(1)}}%</div>
                          </span> -->
                          <!-- <span *ngIf="info.CalculatedWorn!=null"
                            class="Eval-{{ info.CalculatedWorn | wornPercentageToEval}}"
                            style="margin-right: 7px;padding: 7px 21px;">
                            <div>{{info.CalculatedWorn?.toFixed(1)}}%</div>
                          </span> -->
                          <span 
                            class="Eval-{{ info.SumCalculatedWorn | wornPercentageToEval}}"
                            style="margin-right: 7px;padding: 7px 21px;margin-left: 16px;">
                            <div>{{info.SumCalculatedWorn?.toFixed(1)}}%</div>
                          </span>
                           
                         <span *ngIf="info.CalculatedWorn!=null && info.isExpand"
                            class="Eval-{{ info.CalculatedWorn | wornPercentageToEval}}"
                            style="margin-right: 7px;padding: 7px 21px;">
                            <div>{{info.CalculatedWorn?.toFixed(1)}}%</div>
                          </span> 
                          <span *ngIf="info.CalculatedWorn==null && info.isExpand"
                          class="Eval-A"
                          style="margin-right: 7px;padding: 7px 21px;">
                          <div>0.0%</div>
                        </span>
                      </td>
                    </tr>


                    <ng-container *ngIf="info.isExpand">

                      <ng-container *ngFor="let mp of info.MPRecords">
                        <tr>


                          <td class="tdClass" style="padding: 12px 17px;;display:flex;min-height: 54px;">

                            <span *ngIf="mp.HasEstimateMeasurement==true">
                              <i class="material-icons" style="font-size: 19px; color: #2d9cdb;vertical-align: -webkit-baseline-middle;">circle</i>
                            </span>
                            <span *ngIf="mp.HasEstimateMeasurement==false" style="margin-left: 16px;">
                            </span>

                            <span *ngIf="checkedMeasurement" class="Eval-U"
                                  style="margin-right: 7px;padding: 7px 21px; min-width: 100px;max-width: 100px;">
                              <div>{{mp.AverageReading}}</div>
                            </span>

                            <span *ngIf="(mp.AverageReading!='Yes' && mp.AverageReading!='No' && mp.AverageReading!='?') && checkedWorn"
                                  class="Eval-{{ mp.WornPercentage | wornPercentageToEval}}"
                                  style="margin-right: 7px;padding: 7px 21px;    min-width: 100px;max-width: 100px;">
                              <div>{{mp.WornPercentage?.toFixed(1)}}%</div>
                            </span>

                            <span *ngIf="(mp.AverageReading=='Yes' || mp.AverageReading=='No' || mp.AverageReading=='?') && checkedWorn"
                                  class="Eval-U" style="margin-right: 7px;padding: 7px 21px; min-width: 100px;max-width: 100px;">
                              <div>-</div>
                            </span>

                            <span *ngIf="mp.ContributionWornPercentage!=null && checkedWeightedWorn"
                                  class="Eval-U"
                                  style="margin-right: 7px;padding: 7px 21px; min-width: 100px;max-width: 100px;">
                              <div>{{mp.ContributionWornPercentage.toFixed(1)}}%</div>
                            </span>
                            <span *ngIf="mp.ContributionWornPercentage==null && checkedWeightedWorn"
                                  style="margin-right: 7px;padding: 7px 21px; min-width: 100px;max-width: 100px;" class="Eval-U">
                              <div>-</div>
                            </span>

                          </td>
                        </tr>

                      </ng-container>
                    </ng-container>


                  </ng-container>
              </div>



              </ng-container>
          </div>

          </table>
        </div>
      </div>
    </div>



    <div class="panel panel--components">
      <div class="panel__header" style="flex-flow: row-reverse">

      </div>

      <div class="panel__content no-padding">
        <div style="display: flex;flex-direction: row;" *ngIf="RightSystem!=null && inspectionsHistory!=null">
          <div style="width:40%">
            <table class="table table--striped table--full-width">
              <tr>
                <td class="tdClass"> {{eqName}}</td>
                <td class="tdClass">DATE</td>
              </tr>
              <tr>
                <td></td>
                <td class="tdClass">SMU</td>
              </tr>
              <tr *ngIf="(FamilyId==177 || FamilyId==203)">
                <td></td>
                <td class="tdClass">Propel Hrs</td>
              </tr>
              <tr *ngIf="(FamilyId==177 || FamilyId==203)">
                <td></td>
                <td class="tdClass">Propel %</td>
              </tr>

              <tr *ngIf="(FamilyId==177 || FamilyId==203)">
                <td></td>
                <td class="tdClass">Crawler Belt Propel Hrs</td>
              </tr>
              <tr *ngIf="(FamilyId==177 || FamilyId==203)">
                <td></td>
                <td class="tdClass">Crawler Belt Propel %</td>
              </tr>
              <tr>
                <td></td>
                <td class="tdClass">Inspector</td>
              </tr>
              <tr>
                <td class="tdClass">Right Side</td>
                <td *ngIf="(FamilyId!=177 && FamilyId!=203)" class="tdClass">Components</td>
                <td *ngIf="(FamilyId==177 || FamilyId==203)" class="tdClass">Type</td>
              </tr>
              <tr>
                <td></td>
                <td class="tdClass">Residual Life</td>
              </tr>
              <tr>
                <td></td>
                <td class="tdClass">Crawler Belt CMU</td>
              </tr>
              <tr>
                <td></td>
                <td style="padding: 23px;" class="tdClass">Right Side UC Weighted % Worn</td>
              </tr>
              <ng-container *ngFor="let info of RightSystem">
                <tr>
                  <td></td>
                  <td class="tdClass" style="padding: 19px 17px;cursor: pointer;" (click)="ExpandCompatyType(info,2)">
                    <span>
                      <span class="material-icons" style="vertical-align: middle;" *ngIf="!info.isExpand">
                        add
                      </span>
                      <span class="material-icons" style="vertical-align: middle;" *ngIf="info.isExpand">
                        remove
                      </span>
                      <span style="font-weight: bolder;">
                        {{info.Name}} {{
showPosition(info.Position,
                          info.CompartTypeId)
                        }}
                      </span>
                    </span>
                  </td>


                </tr>

                <ng-container *ngIf="info.isExpand">
                  <ng-container *ngFor="let mp of info.MPRecords">
                    <tr>
                      <td class="component-cell">
                        <div class="component-photo-container">
                          <img class="component-photo" [src]="getImage(mp.Photo)"
                               (click)="viewPhoto(mp.Photo)" />
                        </div>
                      </td>
                      <td class="tdClass" style="padding: 19px 17px;cursor: pointer;">
                        <span>
                          {{mp.Name}}
                        </span>
                      </td>
                    </tr>
                  </ng-container>

                </ng-container>
              </ng-container>

            </table>
          </div>

          <div style="    overflow-x: auto;">
            <table class="table table--striped table--full-width">
              <div style="display: flex; flex-direction: row;">
                <ng-container *ngFor="let data of inspectionsHistory">
                  <div>
                  <tr>
                    <td class="tdClass">{{data.Date}}</td>

                  </tr>
                  <tr>

                    <td class="tdClass">{{data.Smu}}</td>
                  </tr>

                  <tr *ngIf="(FamilyId==177 || FamilyId==203)">

                    <td class="tdClass">{{data.EPMU}} </td>
                  </tr>
                  <tr *ngIf="(FamilyId==177 || FamilyId==203)">

                    <td class="tdClass">{{data.PMUpercentage.toFixed(1)}}% </td>
                  </tr>
                  <tr *ngIf="(FamilyId==177 || FamilyId==203)">

                    <td class="tdClass">{{data.CrawlerBeltEPMU}} </td>
                  </tr>
                  <tr *ngIf="(FamilyId==177 || FamilyId==203)">

                        <td class="tdClass">{{data.CrawlerBeltPMUpercentage.toFixed(1)}}% </td>
                      </tr>
                      <tr>
                        <td class="tdClass">{{data.Inspector | aesDecrypt}} </td>
                      </tr>
                      <tr>
                        <td *ngIf="(FamilyId!=177 && FamilyId!=203)" class="tdClass">Worn%</td>
                        <td *ngIf="(FamilyId==177 || FamilyId==203)" class="tdClass SerialAndUnitText">{{data.InspectionType}}</td>
                      </tr>
                      <tr>
                        <td class="tdClass">{{data.MonoblockResidualR}} </td>
                      </tr>
                      <tr>
                        <td class="tdClass">{{data.MonoblockCMUR}} </td>
                      </tr>
                      <tr>
                        <td class="tdClass">
                          <span *ngIf="data.SumWornR!=null" class="Eval-{{ data.SumWornR | wornPercentageToEval}}"
                            style="margin-right: 7px;padding: 7px 21px;">
                            <div>{{data.SumWornR?.toFixed(1)}}%</div>
                          </span>
                          <span *ngIf="data.SumWornR==null" class="Eval-U" style="margin-right: 7px;padding: 7px 21px;">
                            <div>-</div>
                          </span>
                        </td>
                      </tr>
                      <ng-container *ngFor="let info of data.RightSide">
                        <tr>
                          <td class="tdClass" style="display: flex;justify-content: space-between;">
                            <!--TT-3983-->
                            <!-- <span class="Eval-{{ info.Eval}}" style="margin-right: 7px;padding: 7px 21px;">
                              <div>{{info.Worn?.toFixed(1)}}%</div>
                            </span> -->
                            <!-- <span *ngIf="info.CalculatedWorn!=null"
                              class="Eval-{{ info.CalculatedWorn | wornPercentageToEval}}"
                              style="margin-right: 7px; padding: 7px 21px;">
                              <div>{{info.CalculatedWorn?.toFixed(1)}}%</div>
                            </span> -->

                        <span class="Eval-{{ info.SumCalculatedWorn | wornPercentageToEval}}"
                              style="margin-right: 7px;padding: 7px 21px;margin-left: 16px;">
                          <div>{{info.SumCalculatedWorn?.toFixed(1)}}%</div>
                        </span>
                        <span *ngIf="info.CalculatedWorn!=null && info.isExpand"
                              class="Eval-{{ info.CalculatedWorn | wornPercentageToEval}}"
                              style="margin-right: 7px;padding: 7px 21px;">
                          <div>{{info.CalculatedWorn?.toFixed(1)}}%</div>
                        </span>
                        <span *ngIf="info.CalculatedWorn==null && info.isExpand"
                              class="Eval-A"
                              style="margin-right: 7px;padding: 7px 21px;">
                          <div>0.0%</div>
                        </span>
                      </td>
                    </tr>

                    <ng-container *ngIf="info.isExpand">

                      <ng-container *ngFor="let mp of info.MPRecords">
                        <tr>



                          <td class="tdClass" style="padding: 12px 17px;;display:flex;min-height: 54px;">

                            <span *ngIf="mp.HasEstimateMeasurement==true">
                              <i class="material-icons" style="font-size: 19px; color: #2d9cdb;vertical-align: -webkit-baseline-middle;">circle</i>
                            </span>
                            <span *ngIf="mp.HasEstimateMeasurement==false" style="margin-left: 16px;">
                            </span>

                            <span *ngIf="checkedMeasurement" class="Eval-U"
                                  style="margin-right: 7px;padding: 7px 21px; min-width: 100px;max-width: 100px;">
                              <div>{{mp.AverageReading}}</div>
                            </span>

                            <span *ngIf="mp.AverageReading!='Yes' && mp.AverageReading!='No' && mp.AverageReading!='?' && checkedWorn"
                                  class="Eval-{{ mp.WornPercentage | wornPercentageToEval}}"
                                  style="margin-right: 7px;padding: 7px 21px; min-width: 100px;max-width: 100px;">
                              <div>{{mp.WornPercentage?.toFixed(1)}}%</div>
                            </span>

                            <span *ngIf="mp.AverageReading=='Yes' || mp.AverageReading=='No' || mp.AverageReading=='?' && checkedWorn"
                                  class="Eval-U" style="margin-right: 7px;padding: 7px 21px; min-width: 100px;max-width: 100px;">
                              <div>-</div>
                            </span>

                            <span *ngIf="mp.ContributionWornPercentage!=null && checkedWeightedWorn"
                                  class="Eval-U"
                                  style="margin-right: 7px;padding: 7px 21px; min-width: 100px;max-width: 100px;">
                              <div>{{mp.ContributionWornPercentage.toFixed(1)}}%</div>
                            </span>
                            <span *ngIf="mp.ContributionWornPercentage==null && checkedWeightedWorn"
                                  style="margin-right: 7px;padding: 7px 21px; min-width: 100px;max-width: 100px;" class="Eval-U">
                              <div>-</div>
                            </span>

                          </td>
                        </tr>

                      </ng-container>
                    </ng-container>
                  </ng-container>
              </div>



              </ng-container>
          </div>

          </table>
        </div>
      </div>
    </div>
  </div>
</div>

  </div>




</div>
